module.exports = "/_next/static/images/logo-white-610087f3c4bd944245a3f53c2d031577.png";